import React, { useEffect, useState } from 'react';
import AttendanceCalendar from './AttendanceCalendar';

const Attendance = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [days, setDays] = useState([]);
     const today = new Date();
     const year = today.getFullYear();
     const month = String(today.getMonth() + 1).padStart(2, '0');
     const start = `${year}-${month}-01`;
     const end = `${year}-${month}-${new Date(year, today.getMonth() + 1, 0).getDate().toString().padStart(2, '0')}`;

     const [monthRange, setMonthRange] = useState({ start, end });
     const [attendanceSummary, setAttendanceSummary] = useState({
          present: 0,
          absent: 0,
          leave: 0,
          holiday: 0,
     });
     const [holidays, setHolidays] = useState([]); // <-- Add this
     const user_code = sessionStorage.getItem('user_code') || '';
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const token = sessionStorage.getItem('token');


     const [employeeType, setEmployeeType] = useState("Contractual_Employee"); // Add state

     const fetchAttendance = async () => {
          try {
               const url = `${BASE_URL}/getEmployeeAttendance`;
               const payload = {
                    employee_code: user_code,
                    selectedMonth: monthRange.start.slice(0, 7),
                    selectedToMonth: monthRange.end.slice(0, 7)
               };

               const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload)
               });

               const json = await response.json();
               if (json.status && json.data) {
                    setDays(json.data.days || []);
                    setMonthRange(json.data.month_range);
                    setHolidays(json.data.holidays || []);

                    // Get employee type from API response
                    const empType = json.data.employee_info?.emp_type || "Contractual_Employee";
                    setEmployeeType(empType);

                    const fullAttendanceSummary = {
                         present: json.data.attendance.present_days || 0,
                         absent: json.data.attendance.absent_days || 0,
                         leave: 0,
                         holiday: (json.data.holidays || []).length,
                         duty_roster: json.data.duty_roster || [],
                         employee_info: json.data.employee_info || {},
                         month_range: json.data.month_range || {}
                    };

                    setAttendanceSummary(fullAttendanceSummary);
               }
          } catch (err) {
               console.error('Error fetching attendance:', err);
          }
     };
     useEffect(() => {
          fetchAttendance();
     }, []); // This will trigger whenever monthRange changes
     useEffect(() => {
          if (monthRange.start && monthRange.end) {
               fetchAttendance();
          }
     }, [monthRange.start, monthRange.end]);

     const handleMonthChange = (dateObj) => {
          // dateObj is a JS Date for the first day of the selected month
          const year = dateObj.getFullYear();
          const month = dateObj.getMonth() + 1; // JS months are 0-based, convert to 1-based
          const monthStr = String(month).padStart(2, '0');
          // Update the month range for the new month
          const start = `${year}-${monthStr}-01`;
          const end = `${year}-${monthStr}-${new Date(year, month, 0).getDate().toString().padStart(2, '0')}`;

          setMonthRange({ start, end });

          // This will trigger the useEffect to fetch new data
     };

     const weekOffDay = 0;
     return (
          <div>
               <AttendanceCalendar
                    days={days}
                    monthRange={monthRange}
                    attendanceSummary={attendanceSummary}
                    holidays={holidays}
                    onMonthChange={handleMonthChange}
                    weekOffDay={weekOffDay}
                    employeeType={employeeType} // <-- Pass employeeType here!
               />
          </div>
     );
};

export default Attendance;